<form id="dynamic-form" [formGroup]="form">
    <div [ngClass]="{'column-count-2': (isSmallScreen | async)}">
        <app-control *ngFor="let control of controls" [control]="control" [form]="form">
        </app-control>
    </div>
</form>